module.exports = __webpack_public_path__ + "static/agnes-og-image-cea1b3cbfd0e266694767889137fd7ac.png";